import { Injectable } from '@angular/core';
import { cmsApi } from '../constants/constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GoodgovernenceService {

  constructor(private http: HttpClient) { }

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];


  get_GoodgovernenceList() {
    let _getNewsPeriodUrl = cmsApi + '/get_GoodgovernenceList/'
    let _getNewsPeriodBody = { }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_governenceById(governence_id) {
    let _getNewsPeriodUrl = cmsApi + '/get_governenceById/'
    let _getNewsPeriodBody = { governence_id : governence_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_ethicById(ethic_id) {
    let _getNewsPeriodUrl = cmsApi + '/get_ethicById/'
    let _getNewsPeriodBody = { ethic_id : ethic_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_corruptionById(corruptionid) {
    let _getNewsPeriodUrl = cmsApi + '/get_corruptionById/'
    let _getNewsPeriodBody = { corruption_id : corruptionid }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }


  get_productById(product_id) {
    let _getNewsPeriodUrl = cmsApi + '/get_productById/'
    let _getNewsPeriodBody = { product_id : product_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }


  get_ethicList() {
    let _getNewsPeriodUrl = cmsApi + '/get_ethicList/'
    let _getNewsPeriodBody = { IsActive : "1",
    search : "" }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_corruptionList() {
    let _getNewsPeriodUrl = cmsApi + '/get_corruptionList/'
    let _getNewsPeriodBody = { IsActive : "1",
    search : "" }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_productList() {
    let _getNewsPeriodUrl = cmsApi + '/get_productList/'
    let _getNewsPeriodBody = { IsActive : "1",
    search : "" }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }


  changeFormatDate_dd(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day;
    }
  }

  changeFormatDate_MM(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return monthTh['name'];
    }
  }

  changeFormatDate_yy(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return  year;
    }
  }

  changeFormatDate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }

  date_thai_dd(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day);
  }

  date_thai_mm(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (monthTh['name']);
  }

  date_thai_yy(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (year);
  }






}
